import React from 'react'
import EmployeesPanel from '../components/Organisms/EmployeesPanel'
import PhonePanel from '../components/Wrappers/PhonePanel'
import TranslatePhonePanel from '../components/Wrappers/TranslatePhonePanel'
import EmployeeInformationGrid from '../components/Organisms/Grids/EmployeeInformationGrid'
import CreateNewEmployee from '../components/Organisms/CreateNewEmployee'
import EmployeesEmptyState from '../components/Organisms/Emptys/EmployeesEmptyState'
import TabsWrapper from '../components/Wrappers/TabsWrapper'
import {Redirect, Switch, useRouteMatch} from 'react-router-dom'
import PrivateEmployer from '../config/Routes/PrivateEmployer'
import routes, {redirectRoute} from '../config/routes'

const Employees = () => {
  let {path} = useRouteMatch()

  return (
    <TabsWrapper defaultActive={3}>
      <PhonePanel
        container={{
          className: 'ed-grid s-gap-0 m-gap-2 lg-gap-4 m-grid-2 lg-grid-3 lg-px-2',
        }}
      >
        <div>
          <EmployeesPanel />
        </div>

        <TranslatePhonePanel className='s-gap-1 m-gap-2 lg-gap-4 ed-grid lg-grid-2 lg-cols-2 row-gap'>
          <EmployeeInformationGrid />
        </TranslatePhonePanel>
      </PhonePanel>
    </TabsWrapper>
  )
}

export default Employees
